import { render, staticRenderFns } from "./UpdateDriverGroupForm.vue?vue&type=template&id=81f4055c&scoped=true"
import script from "./UpdateDriverGroupForm.vue?vue&type=script&lang=js"
export * from "./UpdateDriverGroupForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateDriverGroupForm.vue?vue&type=style&index=0&id=81f4055c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f4055c",
  null
  
)

export default component.exports